import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import annex6V2Actions, {
	EAnnex6V2Actions,
	EAnnex6V2Constants,
	TAnnex6V2Actions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { commonUtils } from '../../../_common';
import { TAnnex6V2BackendRecord } from '../@types';
import moment from 'moment';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';

const annex6V2HistoryMiddleware: Middleware<{}, IStore> =
	({ dispatch, getState }) =>
		(next) =>
			(action: TAnnex6V2Actions | IAuthActions) => {
				switch (action.type) {
					case EAnnex6V2Actions.HISTORY_LOAD: {
						next(action);
						const job = jobActions(EAnnex6V2Constants.FEATURE, action.type);
						const { providedFilters: filters } = action.payload;
						dispatch(annex6V2Actions.document.setFilter(filters));
						dispatch(
							apiActions.apiRequest<{ logs: { docs: TAnnex6V2BackendRecord[] } }>({
								feature: action.type,
								method: 'GET',
								url: EAnnex6V2Constants.API,
								queryParams: {
									vesselId: filters.vesselId,
									marpolType: EMARPOLDocuments.ANNEX6V2,
									modelName: EMARPOLModelName.MARPOL,
									weekStart: filters.startDate,
									weekEnd: filters.endDate,
									state: {
										$eq: filters?.state ?? undefined
									},
									sortOrder: filters?.sortOrder ?? undefined,
								},
								preExecute() {
									dispatch(job.active({}));
								},
								postExecute: {
									onSuccess({ data }) {
										const annex6V2Records = data.logs.docs.filter(
											(doc) => doc.marpolType === EMARPOLDocuments.ANNEX6V2
										);
										dispatch(
											annex6V2Actions.document.historySet(
												commonUtils.arrayToObject(annex6V2Records)
											)
										);
										dispatch(job.success({}));
									},
									onError() {
										dispatch(job.error({}));
									},
									finally() {
										dispatch(job.idle({}));
									},
								},
							})
						);
						break;
					}
					default: {
						next(action);
						break;
					}
				}
			};
export default annex6V2HistoryMiddleware;
